import {Pipe, PipeTransform} from '@angular/core';
import {Address} from '../../../models/address.model';

@Pipe({
    name: 'addressShort'
})
export class AddressShortPipe implements PipeTransform {

    transform(address: Address): any {
        if (!address) {
            return '';
        }
        const shortAddress = [];
        shortAddress.push(address.city);
        shortAddress.push(address.street);
        return shortAddress
            .filter(Boolean)
            .join(', ')
            .replace(/(^[,\s]+)|([,\s]+$)/g, '');
    }
}
